// src/data/platformsData.js

import SpotifyLogo from '../assets/Images/MusicPlaylist/spotify.svg';
import AppleMusicLogo from '../assets/Images/MusicPlaylist/apple music.svg';
import DeezerLogo from '../assets/Images/MusicPlaylist/Deezer.svg';
import AmazonMusicLogo from '../assets/Images/MusicPlaylist/amazon music.svg';
import JioSaavnLogo from '../assets/Images/MusicPlaylist/jio savan.svg';
import HungamaMusicLogo from '../assets/Images/MusicPlaylist/hungama.svg';
import GaanaLogo from '../assets/Images/MusicPlaylist/gaana.svg';
import BoomplayLogo from '../assets/Images/MusicPlaylist/boomplay.svg';
import AnghamiLogo from '../assets/Images/MusicPlaylist/anghami.svg';
import SnapchatLogo from '../assets/Images/MusicPlaylist/snap.svg';

export const platforms = [
    {
        name: 'Spotify',
        logo: SpotifyLogo,
        description:
            'As the largest dedicated music-streaming platform globally, Spotify boasts over 140 million active users each month, offering a rich selection of popular playlists.',
        strength:
            'Extensive Reach. Your tracks will join a vast catalog of millions of songs, available to an ever-growing audience.',
        features: 'Streaming',
    },
    {
        name: 'Apple Music',
        logo: AppleMusicLogo,
        description:
            'Apple Music offers a vast library of songs and exclusive content, integrating seamlessly with all Apple devices and services.',
        strength:
            'Exclusive Releases. Benefit from Apple’s strong user base and ecosystem for greater exposure.',
        features: 'Streaming, Downloads, Cloud',
    },
    {
        name: 'Deezer',
        logo: DeezerLogo,
        description:
            'Available in more countries than any other streaming service, Deezer puts your music in front of 20 million users.',
        strength: 'Global Reach. Expand your music’s presence worldwide.',
        features: 'Streaming, Downloads',
    },
    {
        name: 'Amazon Music',
        logo: AmazonMusicLogo,
        description:
            'As the largest retailer on the planet, Amazon also offers your music for downloads and streaming in all major markets.',
        strength: 'Global Reach. Access over 80 million listeners.',
        features: 'Streaming, Cloud, Downloads',
    },
    {
        name: 'JioSaavn',
        logo: JioSaavnLogo,
        description:
            'India’s leading digital music service with award-winning mobile features, often dubbed “India’s Spotify.”',
        strength: 'Local Focus & Reach. Reach over 11 million monthly users in India’s booming streaming market.',
        features: 'Streaming',
    },
    {
        name: 'Hungama Music',
        logo: HungamaMusicLogo,
        description:
            'Hungama, a top digital entertainment platform in India, offers a multilingual, multi-genre library to over 65 million monthly users.',
        strength: 'Broad Reach. Make your music accessible across India.',
        features: 'Streaming',
    },
    {
        name: 'Gaana',
        logo: GaanaLogo,
        description:
            'Gaana, one of India’s top music streaming apps, has over 150 million monthly active users.',
        strength: 'Wide Reach. Get discovered by fans in India’s rapidly expanding digital music market.',
        features: 'Streaming',
    },
    {
        name: 'Boomplay Music',
        logo: BoomplayLogo,
        description:
            'Boomplay Music is the #1 music community app in Africa, focusing on building the largest digital music platform across the African continent and diaspora.',
        strength: 'Rapid Growth. With 62 million users and a monthly growth of 700k new users, Boomplay continues to be preloaded on the top-selling smartphone in Africa.',
        features: 'Streaming, Downloads',
    },
    {
        name: 'Anghami',
        logo: AnghamiLogo,
        description:
            'Anghami is the leading music streaming and download service in the Middle East & North Africa.',
        strength: 'Local Focus. Reach new fans in the growing MENA music market.',
        features: 'Streaming, Downloads',
    },
    {
        name: 'Snapchat',
        logo: SnapchatLogo,
        description:
            'Snapchat connects you to an audience of over 306 million daily users who discover new music and artists through the platform’s audio library.',
        strength: 'Wide Reach, Engagement, Discovery.',
        features: 'Streaming, Social, Discovery',
    },
];
